module.exports = __webpack_public_path__ + "static/media/import-icon-blue-light.8db3805c.svg";